import { render, staticRenderFns } from "./AlertRuleDeploymentView.vue?vue&type=template&id=40faf742&lang=pug&"
import script from "./AlertRuleDeploymentView.vue?vue&type=script&lang=ts&"
export * from "./AlertRuleDeploymentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports